import { render, staticRenderFns } from "./Recaptcha.vue?vue&type=template&id=7809f506"
import script from "./Recaptcha.vue?vue&type=script&lang=js"
export * from "./Recaptcha.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports